'use es6';

import PropTypes from 'prop-types';
import FeedbackNpsMobileRating from './FeedbackNpsMobileRating';
import { makeSafeInnerHTML } from 'feedback-utils/sanitize';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FeedbackNpsBoxRatings = ({
  onRatingChange = () => {},
  selectedRating,
  highRangeLabel,
  lowRangeLabel
}) => {
  const ratings = Array.from(Array(11).keys());
  return ratings.map(ratingValue => /*#__PURE__*/_jsxs(FeedbackNpsMobileRating, {
    onRatingChange: onRatingChange,
    selectedRating: selectedRating,
    value: ratingValue,
    children: [ratingValue === 0 && /*#__PURE__*/_jsx("span", {
      dangerouslySetInnerHTML: makeSafeInnerHTML(lowRangeLabel)
    }), ratingValue !== 0 && ratingValue !== 10 && ratingValue, ratingValue === 10 && /*#__PURE__*/_jsx("span", {
      dangerouslySetInnerHTML: makeSafeInnerHTML(highRangeLabel)
    })]
  }, ratingValue));
};
FeedbackNpsBoxRatings.propTypes = {
  onRatingChange: PropTypes.func,
  selectedRating: PropTypes.number
};
export default FeedbackNpsBoxRatings;